/**
 * Copyright 2023 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

export function formatStringNumber(stringNumber?: string) {
  return Number(stringNumber ?? 0);
}
